import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, GoodsCategory, GoodsFilter, NoResult } from '../../../js/ComponentManager'
import { DataContext } from '../../Layout';
/* 개발담당:양유빈
 * 화면기능:검색결과 리스트
 * 세부설명:
*/

export class SearchList extends Component {
    static displayName = SearchList.name;
    static contextType = DataContext;
    constructor(props) {
        super(props);
        this.state = {
            GoodsList: [],
            GoodListPush:[]
        };
        this.CsName = Big3Common.ContentState;
        this.refSearchList = React.createRef();
        this.GoodsCategoryRef = React.createRef();
        this.GoodsFilterRef = React.createRef();
       

        this.CategoryCallback = this.CategoryCallback.bind(this);
        this.handelFilterInit = this.handelFilterInit.bind(this);
        this.FilterCallback = this.FilterCallback.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);
        this.SetSearchText = this.SetSearchText.bind(this);
    }
    SearchModel = {
        Man_Cd: "",
        Mid_Cd: "",
        Sub_Cd: "",
        Display: "all",
        Order_By: "reg_dt",
        Start_Price: 0,
        End_Price: 1000000,
        Goods_Nm: "",
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size

    }
    //초기화
    componentDidMount() {

               

        //상품 상세로 이동 후 되돌아 올대 값 셋업
        const propSearchModel = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchModel, "");
        if (propSearchModel !== "") {
            this.SearchModel = propSearchModel;
        }
        //검색박스에 값 할당(SearchHome에서 온것), 최초 한번
        if (this.props.SearchText !== undefined) {
            let TextValue = this.props.SearchText;
            document.querySelector(".search_box input").value = TextValue;
            this.CallSearchGoodsNameList(TextValue, false);
        }
        
    }
    //Index 페이지에서 SearchText 값이 변경될때 Call
    SetSearchText(SearchText) {
        this.SearchModel.Page_Number = 1;        
        this.CallSearchGoodsNameList(SearchText, false);
    }
    
    //상품검색 조회
    async CallSearchGoodsNameList(SearchText,isAppend) {
        try {
            Big3Common.Util.LoadingOn();
            this.SearchModel.Goods_Nm = SearchText;
            let Data = await Big3Common.Post('api/Search/Goods/GetSearchGoodsNameList', this.SearchModel, true);
            
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let GoodsList = JSON.parse(Data.dataTable);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.GoodListPush;
                    GoodsList.map(list => GoodListPush.push(list));
                    this.setState({ GoodsList: GoodsList, GoodListPush: GoodListPush });
                }
                else {
                    this.setState({ GoodsList: GoodsList, GoodListPush: GoodsList });
                }
                
               
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallSearchGoodsNameList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //카테고리 필터조건 Callback 함수
    CategoryCallback(CategoryCd) {

        this.SearchModel.Man_Cd = CategoryCd.Man_Cd;
        this.SearchModel.Mid_Cd = CategoryCd.Mid_Cd;
        this.SearchModel.Sub_Cd = CategoryCd.Sub_Cd;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        
        this.CallSearchGoodsNameList(this.SearchModel.Goods_Nm, false);
    }
    //필터조건 검색 Callback 함수
    FilterCallback(Filter) {

        this.SearchModel.Display = Filter.Display;
        this.SearchModel.Order_By = Filter.Order_By;
        this.SearchModel.Start_Price = Filter.Start_Price;
        this.SearchModel.End_Price = Filter.End_Price;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;

        this.CallSearchGoodsNameList(this.SearchModel.Goods_Nm, false);
    }
    //필터 초기화
    handelFilterInit() {

        this.GoodsCategoryRef.current.CategoryDataCall();
        this.GoodsFilterRef.current.handleClear_Click();

        this.SearchModel.Man_Cd = "";
        this.SearchModel.Mid_Cd = "";
        this.SearchModel.Sub_Cd = "";
        this.SearchModel.Display = "all";
        this.SearchModel.Order_By = "reg_dt";
        this.SearchModel.Start_Price = 0;
        this.SearchModel.End_Price = 1000000;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.CallSearchGoodsNameList(this.SearchModel.Goods_Nm, false);
    }
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.CallSearchGoodsNameList(this.SearchModel.Goods_Nm,true);
    }
    //상품상세보기 클릭
    async handleGoodsDtl_Click(e, goods_no, uid) {
        this.context.Layout_GoodsDtl(
        {
            goods_no: goods_no,
            uid: uid,
            isshow: true,
            headhide: true,
            scrollevent: false
        });
    }
    Productrender() {
        let GoodListPush = this.state.GoodListPush;
        return (
            <div className="recent_poroducts row row-cols-3 result">
                {
                    GoodListPush.map(list =>
                        <div className="product" key={list.file_no} onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}>
                            <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                SoldoutYn={list.soldout_yn}
                                SimilarityYn="Y"
                            />
                            <div className="shop_name">{list.org_nm}</div>
                            <div className="product_name">{list.goods_nm}</div>
                            <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price) }원` }</div>
                            {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                        </div>
                    )
                }
                {this.SearchModel.Page_Size === this.state.GoodsList.length ? <div className="more_btn_box"><button className="more_btn" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
            </div>
        )
    }
    render() {
        let Productrender = this.Productrender();
        return (
            <>
                
                <div id="parent_goods_list">
                    <div ref={this.refSearchList}>
                        <div className="tap_box">
                            <div className="n_tap"><div className="alert_tap tap_on">상품</div></div>
                            <div className="n_tap"><div className="alert_tap" onClick={() => { this.props.RenderComponent("StoreList"); }}>매장</div></div>
                        </div>
                        <div className="a_margin d_padding container_box">
                            <div className="recent_product result_box">
                                <div className="select_box">
                                    <div className="category_box" onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsCategory');
                                        event.preventDefault();
                                    }}>
                                        <div className="category">카테고리</div>
                                        <div className="category_btn"></div>
                                    </div>
                                    <div className="category_box filter"
                                        onClick={(event) => {
                                            Big3Common.ModalAlert(bootstrap, 'GoodsFilter');
                                            event.preventDefault();
                                        }}
                                    >
                                        <div className="category filter">필터</div>
                                        <div className="category_btn"></div>
                                    </div>
                                    <div className="category_box reset" onClick={this.handelFilterInit}>
                                        <div className="category">초기화</div>
                                        <div className="reset_btn"></div>
                                    </div>
                                </div>
                                {Productrender}
                            </div>
                        </div>
                        <NoResult
                            Visible={this.state.GoodsList.length === 0 ? true : false}
                            Top={"60%"}
                        />
                        <GoodsCategory
                            id="GoodsCategory"
                            CallBack={this.CategoryCallback}
                            ref={this.GoodsCategoryRef}
                        />
                        <GoodsFilter
                            id="GoodsFilter"
                            CallBack={this.FilterCallback}
                            ref={this.GoodsFilterRef}
                        />
                    </div>
                </div>
            </>
        );
    }
}
